import DetalleComprobanteBase from "@/domain/comprobantes/detalle/DetalleComprobanteBase.js";


export default {

    crearDesdeApi(data, config = {}) {
        const detalle = DetalleComprobanteBase.fromApi(data, config);
        console.log("Desde crearDesdeAPi", detalle);
        
        return detalle;
    },

    /* =========================
     * COLECCIÓN (Lógica de Negocio)
     * ========================= */

    agregarProducto({ detalles, producto, cantidad = null, config = {} }) {
        
        const existente = detalles.find(
            d => d.isProducto && d.producto?.id === producto.id
        );

        if (existente) {
            existente.incrementar(cantidad);
            return existente;
        }

        // Aquí pasamos la config que contiene precioVentaManual
        const detalle = DetalleComprobanteBase.desdeProducto(
            producto,
            config,
            cantidad
        );

        detalles.push(detalle);
        return detalle;
    },

    agregarPromocion({ detalles, promocion, cantidad = 1, config = {} }) {
        const detalle = DetalleComprobanteBase.desdePromocion(promocion, config);
        detalle.cantidad = cantidad;
        detalle.normalizar();

        detalles.push(detalle);
        return detalle;
    },
    actualizarConfiguracion(detalles, nuevaConfig) {
        detalles.forEach(detalle => {
            detalle.config = nuevaConfig;
        });
    },

    eliminarDetalle(detalles, detalle) {
        const index = detalles.indexOf(detalle);
        if (index !== -1) {
            detalles.splice(index, 1);
        }
    },

    limpiar(detalles) {
        detalles.splice(0, detalles.length);
    },

    /* =========================
     * CONTROLES DE CANTIDAD
     * ========================= */

    incrementarCantidad(detalle) {
        detalle.incrementar();
    },

    decrementarCantidad(detalle) {
        detalle.decrementar();
    },

    normalizarCantidad(detalle) {
        detalle.normalizarCantidad();
    },

    /* =========================
     * CÁLCULOS (Puente hacia la Clase)
     * ========================= */

    calcularSubtotalSinIva(detalle) {
        // Retorna el neto (precioUnitario o precioVenta según el modo)
        return detalle.subtotalNeto;
    },

    calcularSubtotalConIva(detalle) {
        // Retorna el total final con impuestos (si corresponden)
        return detalle.subtotalConIva;
    },

   
};